module.exports = __webpack_public_path__ + "media/welcome-message/conference@2x-c034872c.png";